import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

/** 1. GET the list of TDS Names (Nature of Payment) */
export const getTDSNames = () =>
    axios.get(`${base}/Accounts/GetTDSNames`);

/** 2. GET the list of DCA codes eligible for TDS configuration */
export const getTDSDCANames = () =>
    axios.get(`${base}/Accounts/GetTDSDCANames`);

/** 3. GET the SubDCA codes under a selected DCA */
export const getTDSSDCANames = (code) =>
    axios.get(`${base}/Accounts/GetTDSSDCANames`, { params: { code } });

/** 4. POST create a new TDS Name (Nature of Payment) master entry */
export const saveTDSName = ({ AddTdsName, AddTdscode }) =>
    axios.post(`${base}/Accounts/SaveTDSName`, { AddTdsName, AddTdscode });

/** 5. GET the saved TDS configuration grid, optionally filtered by a TDS Name id */
export const getTDSConfigDetails = (code) =>
    axios.get(`${base}/Accounts/GetTDSConfigdetails`, { params: { code } });

/** 6. POST save a new TDS configuration (DCA/SDCA/WEF date/rates) entry for a TDS Name */
export const saveTDSConfigDetails = ({ TdsNames, DCACode, SDCACode, TDSDate, HUFRate, OtherRate, Createdby }) =>
    axios.post(`${base}/Accounts/SaveTDSConfigDetails`, { TdsNames, DCACode, SDCACode, TDSDate, HUFRate, OtherRate, Createdby });
